import { create } from "zustand";
import { persist } from "zustand/middleware";

// Keep the per-dataset id lists bounded
const MAX_IDS_PER_DATASET = 100;

interface SeenModelJobsStore {
  // Jobs the user has looked at in the Model Jobs panel
  seenByDataset: Record<string, string[]>;
  // Finished jobs we already showed a "finished" notice for
  notifiedByDataset: Record<string, string[]>;
  markSeen: (datasetId: string, jobIds: string[]) => void;
  markNotified: (datasetId: string, jobIds: string[]) => void;
}

const mergeIds = (current: string[] = [], added: string[]) =>
  Array.from(new Set([...added, ...current])).slice(0, MAX_IDS_PER_DATASET);

export const useSeenModelJobsStore = create<SeenModelJobsStore>()(
  persist(
    (set) => ({
      seenByDataset: {},
      notifiedByDataset: {},
      markSeen: (datasetId, jobIds) =>
        set((state) => ({
          seenByDataset: {
            ...state.seenByDataset,
            [datasetId]: mergeIds(state.seenByDataset[datasetId], jobIds),
          },
        })),
      markNotified: (datasetId, jobIds) =>
        set((state) => ({
          notifiedByDataset: {
            ...state.notifiedByDataset,
            [datasetId]: mergeIds(state.notifiedByDataset[datasetId], jobIds),
          },
        })),
    }),
    {
      name: "vl-model-jobs-seen",
      partialize: (state) => ({
        seenByDataset: state.seenByDataset,
        notifiedByDataset: state.notifiedByDataset,
      }),
    },
  ),
);
